import { required, minLength } from '@vuelidate/validators'

export const PASSWORD_MIN_LENGTH = 6
export const ACTIVATE_PASSWORD_MIN_LENGTH = 8

export const CompaniesSetPasswordValidation = {
    password: { required, minLength: minLength(ACTIVATE_PASSWORD_MIN_LENGTH) },
}

export const CompaniesGenerateContractValidation = {
    fullname_initials: { required },
    base: { required },
}

// export const CompaniesPayersValidation = {
//     base: { required },
// }
